import Events from '../lib/events';

export default class InputFile {
  static params = {
    inputSelector: 'input[type="file"]',
    previewSelector: '.field__file',
    previewClassName: 'field__file',
    reset: {
      ru: 'Сбросить выбор',
      en: 'Reset selection'
    }
  };

  constructor($container) {
    this.$container = $container;
    this.$element = this.$container.querySelector(InputFile.params.inputSelector);
    this.previews = [];
    this.events = new Events(this.$container);

    this.bindEvents();
  }

  bindEvents() {
    this.events.bind('change', InputFile.params.inputSelector, (event) => {
      this.updatePreviews();
    });
    this.events.bind('click', InputFile.params.previewSelector, (event) => {
      event.preventDefault();
      this.reset();
    });
  }

  reset() {
    this.$element.value = '';
    this.updatePreviews();

    console.log('reset');
  }

  resetPreviews() {
    this.previews.forEach(($preview) => {
      $preview.remove();
    });
    this.previews = [];
  }

  drawPreviews() {
    let loopEnd = this.$element.files.length;

    for (let loopIndex = 0; loopIndex < loopEnd; loopIndex++) {
      let file = this.$element.files.item(loopIndex);
      let fileReader = new FileReader();

      fileReader.onload = (event) => {
        this.addPreview(event.target.result);
      };

      fileReader.readAsDataURL(file);
    }
  }

  addPreview(previewData) {
    let previewElement = document.createElement('div');
    previewElement.className = InputFile.params.previewClassName;
    previewElement.style.backgroundImage = `url('${previewData}')`;
    previewElement.title = InputFile.params.reset[document.documentElement.lang];
    this.$container.prepend(previewElement);
    this.previews.push(previewElement);
  }

  updatePreviews() {
    this.resetPreviews();
    this.drawPreviews();
  }

  static initAll(selector) {
    document.querySelectorAll(selector).forEach(($container) => {
      new InputFile($container);
    });
  }
}
